<template>
  <div>
    <BaseHeadline :icon="icon" :subtitle="subtitle">
      <template v-slot:headlineBtns>
        <slot v-if="!$vuetify.breakpoint.mobile" name="headlineBtns"></slot>
        <v-btn-toggle
          v-if="isTrysilhus || (!isTrysilhus && isMainContactPerson)"
          v-model="showAll.value"
          class="mr-3 mb-0"
          mandatory
          color="primary"
          dense
        >
          <v-btn depressed :value="false" @click="changeShowAll(false)">
            Vis mine
          </v-btn>

          <v-btn depressed :value="true" @click="changeShowAll(true)">
            Vis alle
          </v-btn>
        </v-btn-toggle>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-3 mb-0" color="primary" v-bind="attrs" v-on="on">
              Sorter
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, index) in sortData"
                :key="index"
                @click="itemSelected(item)"
                :class="{ itemIsActive: item.selected }"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon :color="item.sortDesc ? 'primary' : 'grey'">
                    mdi-arrow-down
                  </v-icon>
                  <v-icon :color="item.sortDesc === false ? 'primary' : 'grey'">
                    mdi-arrow-up
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn
          v-if="isFilterOn"
          outlined
          class="mr-3 mb-0"
          color="primary"
          depressed
          @click="resettFilter"
        >
          Slett filter
        </v-btn>

        <v-badge
          class="mr-3 mb-0 badgeFlex"
          :content="filterCount"
          :value="filterCount"
          color="secondary"
          bordered
          overlap
        >
          <v-btn color="primary" depressed @click="openFilter"> Filter </v-btn>
        </v-badge>

        <v-btn
          class="mr-3 mb-0"
          color="primary"
          depressed
          @click="changeShowTable(!showTable)"
        >
          <v-icon left>
            {{ showTable ? "mdi-view-grid" : "mdi-view-list" }}
          </v-icon>
          {{ showTable ? "Kort" : "Tabell" }}
        </v-btn>
      </template>
    </BaseHeadline>

    <slot v-if="$vuetify.breakpoint.mobile" name="btnMobile"></slot>

    <v-btn-toggle
      v-if="
        $vuetify.breakpoint.mobile &&
        (isTrysilhus || (!isTrysilhus && isMainContactPerson))
      "
      v-model="showAll.value"
      style="width: 50%"
      class="mt-2 mb-2"
      mandatory
      color="primary"
      dense
    >
      <v-btn block exact depressed :value="false" @click="changeShowAll(false)">
        Vis mine
      </v-btn>

      <v-btn exact block depressed :value="true" @click="changeShowAll(true)">
        Vis alle
      </v-btn>
    </v-btn-toggle>

    <FilterBar
      class="mt-2"
      v-if="$vuetify.breakpoint.mobile"
      :buttons="filterButtons"
      @filter="openFilter"
      @removeFilter="resettFilter"
    />

    <!-- <v-radio-group
      v-if="isTrysilhus && $vuetify.breakpoint.mobile"
      v-model="showAll.value"
      row
      hide-details="auto"
      :class="{ 'mb-3': showTable && $vuetify.breakpoint.mobile }"
    >
      <v-radio
        label="Vis mine"
        :value="false"
        :ripple="false"
        @click="changeShowAll(false)"
      ></v-radio>
      <v-radio
        label="Vis alle"
        :value="true"
        :ripple="false"
        @click="changeShowAll(true)"
      ></v-radio>
    </v-radio-group> -->
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import { FilterBtnObject } from "@/types/interface";
import { HeaderObject } from "@/types/tableInterface";
import arraysCheck from "@/helpers/arraysCheck";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";

import FilterBar from "@/components/shared/FilterBar.vue";

export default Vue.extend({
  props: {
    headers: {
      type: Array as () => Array<HeaderObject>,
    },
    icon: {
      type: String,
    },
    subtitle: {
      type: String,
      default: "",
    },
    tableId: {
      type: String,
      default: "",
    },
    sortData: {
      type: Array,
    },
    sortBy: {
      type: Array || null,
    },
    sortDesc: {
      type: Array || null,
    },
  },

  methods: {
    changeShowTable(value: boolean) {
      this.$emit("changeShowTable", value);
    },
    async changeShowAll(value: boolean) {
      this.$emit("changeShowAll", value);
    },
    resettFilter() {
      this.$emit("resettFilter");
    },
    openFilter() {
      this.$emit("openFilter");
    },
    itemSelected(item) {
      this.$emit("clickSort", item);
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
      showTable: "tables/showTable",
      showAll: "tables/showAll",
      defaultTableHeaders: "tables/defaultTableHeaders",
    }),

    filterCount() {
      var headers = this.headers as Array<HeaderObject>;

      return headers.filter((x) => {
        if (Array.isArray(x.filterValues)) {
          return x.filterValues.length > 0 && x.show && !x.disabled;
        }
        return x.filterValues && x.show && !x.disabled;
      }).length;
    },
    isFilterOn(): boolean {
      //chakc if sorted is changed
      if (
        (this.sortBy &&
          !arraysCheck.ArrayIsEqual(
            this.sortBy,
            this.defaultTableHeaders.sortBy
          )) ||
        (this.sortDesc &&
          !arraysCheck.ArrayIsEqual(
            this.sortDesc,
            this.defaultTableHeaders.sortDesc
          ))
      ) {
        return true;
      } else if (
        this.headers &&
        this.defaultTableHeaders &&
        this.defaultTableHeaders.headers &&
        this.tableId &&
        this.defaultTableHeaders.tableId === this.tableId
      ) {
        //Chack if default filterValues is different from filterValues by type
        return this.headers.some((x) => {
          var defaultFilterValues = this.defaultTableHeaders.headers.find(
            (y) => y.value === x.value
          )?.filterValues;

          if (
            Array.isArray(defaultFilterValues) &&
            Array.isArray(x.filterValues)
          ) {
            //Sort array. To work when compare eg: array1 = [2,3,1,4]; array2 = [1,2,3,4];
            return !arraysCheck.ArrayIsEqual(
              defaultFilterValues,
              x.filterValues
            );
          } else {
            //If filtervalue is "" and null
            var isNull = !defaultFilterValues && !x.filterValues;
            return !isNull && defaultFilterValues !== x.filterValues;
          }
        });
      }
      return false;
    },
    filterButtons(): Array<FilterBtnObject> {
      var buttons = [
        {
          show: this.isFilterOn ? true : false,
          name: "Slett filter",
          color: "lightGrey",
          emit: "removeFilter",
        },
        {
          show: true,
          name: "Filter",
          color: "primary",
          emit: "filter",
          badge: this.filterCount,
          badgeColor: "yellow",
        },
      ];
      return buttons as Array<FilterBtnObject>;
    },
  },
  components: {
    BaseHeadline,
    FilterBar,
  },
});
</script>

<style lang="scss" scoped>
.badgeFlex {
  flex: 0 0 auto;
}
.itemIsActive {
  color: inherit !important;
  &:before {
    opacity: 0.12 !important;
  }
}
</style>
